import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import FileSaver from 'file-saver';
import Papa from 'papaparse';

export default Controller.extend({
  formatDateService: service(),

  actionMenuItems: computed(function () {
    return [
      {
        label: 'Download',
        svgJar: 'download',
        onClick: () => {
          this.send('download');
        },
      },
    ];
  }),

  download: action(function () {
    let rows = [
      [
        'Donor Name',
        'Donor Id',
        'User',
        'Changed On',
        'Old Address 1',
        'New Address 1',
        'Old Address 2',
        'New Address 2',
        'Old City',
        'New City',
        'Old State',
        'New State',
        'Old Zip Code',
        'New Zip Code',
      ],
    ];

    this.model.forEach((item) => {
      rows.push([
        item.entityName,
        item.entityHostId,
        `${item.userName} (${item.userEmail})`,
        this.formatDateService.formatForFile(item.createdAt),
        item.oldAddress.address1,
        item.newAddress.address1,
        item.oldAddress.address2,
        item.newAddress.address2,
        item.oldAddress.city,
        item.newAddress.city,
        item.oldAddress.state,
        item.newAddress.state,
        item.oldAddress.zip,
        item.newAddress.zip,
      ]);
    });

    let csv = Papa.unparse(rows);
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, 'AddressChanges.csv', true);
  }),
});
